export let huntPlannerFilterOptions = (payload) => {
    return {
        type: 'HUNT_PLANNER_FILTER_OPTIONS',
        payload: payload
    }
}
